import {ChangeDetectorRef, Component, OnInit} from "@angular/core";
import {AbstractVisbosComponent} from "../../../core/visbos-core/components/abstract-visbos.component";
import {SessionActions} from "../../../shared/actions/session.actions";

@Component({
  selector: 'vb-profile-view',
  templateUrl: './profile-view.component.html',
  styleUrls: ['./profile-view.component.css']
})
export class ProfileViewComponent extends AbstractVisbosComponent implements OnInit {


  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef) {
    super(sessionActions, cd);
  }

  ngOnInit() {
    super.ngOnInit();
  }

}



// WEBPACK FOOTER //
// ./src/app/crm/components/profile-view/profile-view.component.ts